import {
  Box,
  CircularProgress,
  Grid,
  LinearProgress,
  styled,
  Typography,
} from "@mui/material";

import { MenuPopover } from "@/components";
import { ContainedButton } from "@/common";

export const StyledContainedButton = styled(ContainedButton)(() => ({
  borderRadius: "6px !important",
  borderColor: "#E6E7E7",
  width: "fit-content",
}));

export const StyledDeleteContainedButton = styled(ContainedButton)(() => ({
  borderRadius: "6px !important",
  borderColor: "#E6E7E7",
  width: "fit-content",
  color: "#EA4334",
}));

export const LeftFilters = styled(Box)({
  display: "flex",
  gap: "20px",
});

export const RightFilters = styled(Box)({
  display: "flex",
  justifyContent: "right",
  gap: "20px",
});

export const StyledMenuPopover = styled(MenuPopover)(({ theme, sx }) => ({
  "& .MuiPaper-root": {
    width: 231, // Adjust the width according to your needs
    maxWidth: "unset",

    padding: theme.spacing(1),
    borderRadius: 8,
    boxShadow: "0px 10px 10px 0px", // For the shadow effect
    "& .MuiTypography-root": {
      padding: "10px 16px 10px 16px",
      cursor: "pointer",
    },
    "& .MuiTypography-root:hover": {
      backgroundColor: "#0B494B26", // Light blue on hover
      color: "#0B494B",
      borderRadius: 4,
    },
    "& .MuiList-root": {
      padding: 0,
    },
    "& .MuiListItem-root": {
      padding: theme.spacing(1, 2),

      "&:first-of-type": {
        backgroundColor: "#E7F3FF", // Background for the first item
        fontWeight: "bold", // Bold text for the first item
      },
    },
    ...sx,
  },
}));

export const Backdrop = styled("div")(({ theme }) => ({
  position: "fixed",
  top: 0,
  left: 0,
  width: "100vw",
  height: "100vh",
  backgroundColor: "rgba(0, 0, 0, 0.5)", // Adjust the opacity for a faded effect
  zIndex: theme.zIndex.modal - 1, // Ensure it stays behind the Popover
}));

export const StyledProcessBox = styled(Box)(({ theme }) => ({
  display: "flex",
  flexDirection: "column",
  alignItems: "flex-start",
  justifyContent: "center",
  padding: theme.spacing(2),
  borderRadius: "8px",
  boxShadow: theme.shadows[1],
  backgroundColor: "white",
  width: "100%",
  marginBottom: theme.spacing(3),
  "& a": {
    color: "#0b494b",
    textDecoration: "unset",
  },
  "& a:hover": {
    textDecoration: "underline",
  },
}));

export const StyledLoaderText = styled(Box)(({ theme }) => ({
  display: "flex",
  alignItems: "center",
  marginBottom: theme.spacing(1),
}));

export const GradientCircularProgress = styled(CircularProgress)({
  width: "16px",
  height: "16px",
  "svg circle": { stroke: "url(#my_gradient)" },
});

export const BodyText = styled(Typography)(({ theme }) => ({
  marginBottom: theme.spacing(2),
}));

export const ProgressContainer = styled(Box)({
  display: "flex",
  alignItems: "center",
  width: "100%",
});

export const StyledLinearProgress = styled(LinearProgress)(({ theme }) => ({
  flexGrow: 1,
  marginRight: theme.spacing(2),
  height: 8,
  borderRadius: 2,
  backgroundColor: "#f0f0f0",
}));

export const PercentageText = styled(Typography)({
  color: "#2E2C34",
});

export const StyledHeadeButtons = styled(Grid)(({ theme }) => ({
  marginBottom: theme.spacing(3),
}));
